{
  "source": "legacy/cdm2026_v2.html + lieux officiels (scripts/data/official-venues.json)",
  "placeholderGrammar": "1X/2X = vainqueur/2e du groupe X ; 3:ABCDF = 3e issu d'un de ces groupes (table specs/00) ; W73/L101 = vainqueur/perdant du match.",
  "groupIdNote": "Les matchs de groupes n'ont pas d'identifiant dans le legacy : ids 1-72 attribués par ordre chronologique (égalité départagée par lettre de groupe). M73-M104 natifs du legacy. home/away des groupes = désignation officielle FIFA (peut différer de l'ordre interne du legacy, sans impact moteur).",
  "venueNote": "stadium/city/hostCountry/timezone issus du calendrier officiel (Wikipédia groupes A-L + knockout stage, vérifiés contre les villes/pays du legacy). stadiumFifa = nom de stade FIFA sans sponsor.",
  "matches": [
    {
      "id": 1,
      "stage": "group",
      "group": "A",
      "matchday": 1,
      "home": "MEX",
      "away": "RSA",
      "utcDateTime": "2026-06-11T19:00:00Z",
      "stadium": "Estadio Azteca",
      "stadiumFifa": "Estadio Ciudad de México",
      "city": "Mexico",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "venueId": "azteca"
    },
    {
      "id": 2,
      "stage": "group",
      "group": "A",
      "matchday": 1,
      "home": "KOR",
      "away": "CZE",
      "utcDateTime": "2026-06-12T02:00:00Z",
      "stadium": "Estadio Akron",
      "stadiumFifa": "Estadio Guadalajara",
      "city": "Guadalajara",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "venueId": "akron"
    },
    {
      "id": 3,
      "stage": "group",
      "group": "B",
      "matchday": 1,
      "home": "CAN",
      "away": "BIH",
      "utcDateTime": "2026-06-12T19:00:00Z",
      "stadium": "BMO Field",
      "stadiumFifa": "Toronto Stadium",
      "city": "Toronto",
      "hostCountry": "ca",
      "timezone": "America/Toronto",
      "venueId": "bmo"
    },
    {
      "id": 4,
      "stage": "group",
      "group": "D",
      "matchday": 1,
      "home": "USA",
      "away": "PAR",
      "utcDateTime": "2026-06-13T01:00:00Z",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "city": "Los Angeles",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "sofi"
    },
    {
      "id": 5,
      "stage": "group",
      "group": "B",
      "matchday": 1,
      "home": "QAT",
      "away": "SUI",
      "utcDateTime": "2026-06-13T19:00:00Z",
      "stadium": "Levi's Stadium",
      "stadiumFifa": "San Francisco Bay Area Stadium",
      "city": "San Francisco",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "levis"
    },
    {
      "id": 6,
      "stage": "group",
      "group": "C",
      "matchday": 1,
      "home": "BRA",
      "away": "MAR",
      "utcDateTime": "2026-06-13T22:00:00Z",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "city": "New York–NJ",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "metlife"
    },
    {
      "id": 7,
      "stage": "group",
      "group": "C",
      "matchday": 1,
      "home": "HTI",
      "away": "SCO",
      "utcDateTime": "2026-06-14T01:00:00Z",
      "stadium": "Gillette Stadium",
      "stadiumFifa": "Boston Stadium",
      "city": "Boston",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "gillette"
    },
    {
      "id": 8,
      "stage": "group",
      "group": "D",
      "matchday": 1,
      "home": "AUS",
      "away": "TUR",
      "utcDateTime": "2026-06-14T04:00:00Z",
      "stadium": "BC Place",
      "stadiumFifa": "BC Place Vancouver",
      "city": "Vancouver",
      "hostCountry": "ca",
      "timezone": "America/Vancouver",
      "venueId": "bcplace"
    },
    {
      "id": 9,
      "stage": "group",
      "group": "E",
      "matchday": 1,
      "home": "GER",
      "away": "CUW",
      "utcDateTime": "2026-06-14T17:00:00Z",
      "stadium": "NRG Stadium",
      "stadiumFifa": "Houston Stadium",
      "city": "Houston",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "nrg"
    },
    {
      "id": 10,
      "stage": "group",
      "group": "F",
      "matchday": 1,
      "home": "NED",
      "away": "JPN",
      "utcDateTime": "2026-06-14T20:00:00Z",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "city": "Dallas",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "att"
    },
    {
      "id": 11,
      "stage": "group",
      "group": "E",
      "matchday": 1,
      "home": "CIV",
      "away": "ECU",
      "utcDateTime": "2026-06-14T23:00:00Z",
      "stadium": "Lincoln Financial Field",
      "stadiumFifa": "Philadelphia Stadium",
      "city": "Philadelphie",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "lincoln"
    },
    {
      "id": 12,
      "stage": "group",
      "group": "F",
      "matchday": 1,
      "home": "SWE",
      "away": "TUN",
      "utcDateTime": "2026-06-15T02:00:00Z",
      "stadium": "Estadio BBVA",
      "stadiumFifa": "Estadio Monterrey",
      "city": "Monterrey",
      "hostCountry": "mx",
      "timezone": "America/Monterrey",
      "venueId": "bbva"
    },
    {
      "id": 13,
      "stage": "group",
      "group": "H",
      "matchday": 1,
      "home": "ESP",
      "away": "CPV",
      "utcDateTime": "2026-06-15T16:00:00Z",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "city": "Atlanta",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "mercedes"
    },
    {
      "id": 14,
      "stage": "group",
      "group": "G",
      "matchday": 1,
      "home": "BEL",
      "away": "EGY",
      "utcDateTime": "2026-06-15T19:00:00Z",
      "stadium": "Lumen Field",
      "stadiumFifa": "Seattle Stadium",
      "city": "Seattle",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "lumen"
    },
    {
      "id": 15,
      "stage": "group",
      "group": "H",
      "matchday": 1,
      "home": "KSA",
      "away": "URU",
      "utcDateTime": "2026-06-15T22:00:00Z",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "city": "Miami",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "hardrock"
    },
    {
      "id": 16,
      "stage": "group",
      "group": "G",
      "matchday": 1,
      "home": "IRN",
      "away": "NZL",
      "utcDateTime": "2026-06-16T01:00:00Z",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "city": "Los Angeles",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "sofi"
    },
    {
      "id": 17,
      "stage": "group",
      "group": "I",
      "matchday": 1,
      "home": "FRA",
      "away": "SEN",
      "utcDateTime": "2026-06-16T19:00:00Z",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "city": "New York–NJ",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "metlife"
    },
    {
      "id": 18,
      "stage": "group",
      "group": "I",
      "matchday": 1,
      "home": "IRQ",
      "away": "NOR",
      "utcDateTime": "2026-06-16T22:00:00Z",
      "stadium": "Gillette Stadium",
      "stadiumFifa": "Boston Stadium",
      "city": "Boston",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "gillette"
    },
    {
      "id": 19,
      "stage": "group",
      "group": "J",
      "matchday": 1,
      "home": "ARG",
      "away": "ALG",
      "utcDateTime": "2026-06-17T01:00:00Z",
      "stadium": "Arrowhead Stadium",
      "stadiumFifa": "Kansas City Stadium",
      "city": "Kansas City",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "arrowhead"
    },
    {
      "id": 20,
      "stage": "group",
      "group": "J",
      "matchday": 1,
      "home": "AUT",
      "away": "JOR",
      "utcDateTime": "2026-06-17T04:00:00Z",
      "stadium": "Levi's Stadium",
      "stadiumFifa": "San Francisco Bay Area Stadium",
      "city": "San Francisco",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "levis"
    },
    {
      "id": 21,
      "stage": "group",
      "group": "K",
      "matchday": 1,
      "home": "POR",
      "away": "COD",
      "utcDateTime": "2026-06-17T17:00:00Z",
      "stadium": "NRG Stadium",
      "stadiumFifa": "Houston Stadium",
      "city": "Houston",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "nrg"
    },
    {
      "id": 22,
      "stage": "group",
      "group": "L",
      "matchday": 1,
      "home": "ENG",
      "away": "CRO",
      "utcDateTime": "2026-06-17T20:00:00Z",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "city": "Dallas",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "att"
    },
    {
      "id": 23,
      "stage": "group",
      "group": "L",
      "matchday": 1,
      "home": "GHA",
      "away": "PAN",
      "utcDateTime": "2026-06-17T23:00:00Z",
      "stadium": "BMO Field",
      "stadiumFifa": "Toronto Stadium",
      "city": "Toronto",
      "hostCountry": "ca",
      "timezone": "America/Toronto",
      "venueId": "bmo"
    },
    {
      "id": 24,
      "stage": "group",
      "group": "K",
      "matchday": 1,
      "home": "UZB",
      "away": "COL",
      "utcDateTime": "2026-06-18T02:00:00Z",
      "stadium": "Estadio Azteca",
      "stadiumFifa": "Estadio Ciudad de México",
      "city": "Mexico",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "venueId": "azteca"
    },
    {
      "id": 25,
      "stage": "group",
      "group": "A",
      "matchday": 2,
      "home": "CZE",
      "away": "RSA",
      "utcDateTime": "2026-06-18T16:00:00Z",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "city": "Atlanta",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "mercedes"
    },
    {
      "id": 26,
      "stage": "group",
      "group": "B",
      "matchday": 2,
      "home": "SUI",
      "away": "BIH",
      "utcDateTime": "2026-06-18T19:00:00Z",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "city": "Los Angeles",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "sofi"
    },
    {
      "id": 27,
      "stage": "group",
      "group": "B",
      "matchday": 2,
      "home": "CAN",
      "away": "QAT",
      "utcDateTime": "2026-06-18T22:00:00Z",
      "stadium": "BC Place",
      "stadiumFifa": "BC Place Vancouver",
      "city": "Vancouver",
      "hostCountry": "ca",
      "timezone": "America/Vancouver",
      "venueId": "bcplace"
    },
    {
      "id": 28,
      "stage": "group",
      "group": "A",
      "matchday": 2,
      "home": "MEX",
      "away": "KOR",
      "utcDateTime": "2026-06-19T01:00:00Z",
      "stadium": "Estadio Akron",
      "stadiumFifa": "Estadio Guadalajara",
      "city": "Guadalajara",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "venueId": "akron"
    },
    {
      "id": 29,
      "stage": "group",
      "group": "D",
      "matchday": 2,
      "home": "USA",
      "away": "AUS",
      "utcDateTime": "2026-06-19T19:00:00Z",
      "stadium": "Lumen Field",
      "stadiumFifa": "Seattle Stadium",
      "city": "Seattle",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "lumen"
    },
    {
      "id": 30,
      "stage": "group",
      "group": "C",
      "matchday": 2,
      "home": "SCO",
      "away": "MAR",
      "utcDateTime": "2026-06-19T22:00:00Z",
      "stadium": "Gillette Stadium",
      "stadiumFifa": "Boston Stadium",
      "city": "Boston",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "gillette"
    },
    {
      "id": 31,
      "stage": "group",
      "group": "C",
      "matchday": 2,
      "home": "BRA",
      "away": "HTI",
      "utcDateTime": "2026-06-20T00:30:00Z",
      "stadium": "Lincoln Financial Field",
      "stadiumFifa": "Philadelphia Stadium",
      "city": "Philadelphie",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "lincoln"
    },
    {
      "id": 32,
      "stage": "group",
      "group": "D",
      "matchday": 2,
      "home": "TUR",
      "away": "PAR",
      "utcDateTime": "2026-06-20T03:00:00Z",
      "stadium": "Levi's Stadium",
      "stadiumFifa": "San Francisco Bay Area Stadium",
      "city": "San Francisco",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "levis"
    },
    {
      "id": 33,
      "stage": "group",
      "group": "F",
      "matchday": 2,
      "home": "NED",
      "away": "SWE",
      "utcDateTime": "2026-06-20T17:00:00Z",
      "stadium": "NRG Stadium",
      "stadiumFifa": "Houston Stadium",
      "city": "Houston",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "nrg"
    },
    {
      "id": 34,
      "stage": "group",
      "group": "E",
      "matchday": 2,
      "home": "GER",
      "away": "CIV",
      "utcDateTime": "2026-06-20T20:00:00Z",
      "stadium": "BMO Field",
      "stadiumFifa": "Toronto Stadium",
      "city": "Toronto",
      "hostCountry": "ca",
      "timezone": "America/Toronto",
      "venueId": "bmo"
    },
    {
      "id": 35,
      "stage": "group",
      "group": "E",
      "matchday": 2,
      "home": "ECU",
      "away": "CUW",
      "utcDateTime": "2026-06-21T00:00:00Z",
      "stadium": "Arrowhead Stadium",
      "stadiumFifa": "Kansas City Stadium",
      "city": "Kansas City",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "arrowhead"
    },
    {
      "id": 36,
      "stage": "group",
      "group": "F",
      "matchday": 2,
      "home": "TUN",
      "away": "JPN",
      "utcDateTime": "2026-06-21T04:00:00Z",
      "stadium": "Estadio BBVA",
      "stadiumFifa": "Estadio Monterrey",
      "city": "Monterrey",
      "hostCountry": "mx",
      "timezone": "America/Monterrey",
      "venueId": "bbva"
    },
    {
      "id": 37,
      "stage": "group",
      "group": "H",
      "matchday": 2,
      "home": "ESP",
      "away": "KSA",
      "utcDateTime": "2026-06-21T16:00:00Z",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "city": "Atlanta",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "mercedes"
    },
    {
      "id": 38,
      "stage": "group",
      "group": "G",
      "matchday": 2,
      "home": "BEL",
      "away": "IRN",
      "utcDateTime": "2026-06-21T19:00:00Z",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "city": "Los Angeles",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "sofi"
    },
    {
      "id": 39,
      "stage": "group",
      "group": "H",
      "matchday": 2,
      "home": "URU",
      "away": "CPV",
      "utcDateTime": "2026-06-21T22:00:00Z",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "city": "Miami",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "hardrock"
    },
    {
      "id": 40,
      "stage": "group",
      "group": "G",
      "matchday": 2,
      "home": "NZL",
      "away": "EGY",
      "utcDateTime": "2026-06-22T01:00:00Z",
      "stadium": "BC Place",
      "stadiumFifa": "BC Place Vancouver",
      "city": "Vancouver",
      "hostCountry": "ca",
      "timezone": "America/Vancouver",
      "venueId": "bcplace"
    },
    {
      "id": 41,
      "stage": "group",
      "group": "J",
      "matchday": 2,
      "home": "ARG",
      "away": "AUT",
      "utcDateTime": "2026-06-22T17:00:00Z",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "city": "Dallas",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "att"
    },
    {
      "id": 42,
      "stage": "group",
      "group": "I",
      "matchday": 2,
      "home": "FRA",
      "away": "IRQ",
      "utcDateTime": "2026-06-22T21:00:00Z",
      "stadium": "Lincoln Financial Field",
      "stadiumFifa": "Philadelphia Stadium",
      "city": "Philadelphie",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "lincoln"
    },
    {
      "id": 43,
      "stage": "group",
      "group": "I",
      "matchday": 2,
      "home": "NOR",
      "away": "SEN",
      "utcDateTime": "2026-06-23T00:00:00Z",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "city": "New York–NJ",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "metlife"
    },
    {
      "id": 44,
      "stage": "group",
      "group": "J",
      "matchday": 2,
      "home": "JOR",
      "away": "ALG",
      "utcDateTime": "2026-06-23T03:00:00Z",
      "stadium": "Levi's Stadium",
      "stadiumFifa": "San Francisco Bay Area Stadium",
      "city": "San Francisco",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "levis"
    },
    {
      "id": 45,
      "stage": "group",
      "group": "K",
      "matchday": 2,
      "home": "POR",
      "away": "UZB",
      "utcDateTime": "2026-06-23T17:00:00Z",
      "stadium": "NRG Stadium",
      "stadiumFifa": "Houston Stadium",
      "city": "Houston",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "nrg"
    },
    {
      "id": 46,
      "stage": "group",
      "group": "L",
      "matchday": 2,
      "home": "ENG",
      "away": "GHA",
      "utcDateTime": "2026-06-23T20:00:00Z",
      "stadium": "Gillette Stadium",
      "stadiumFifa": "Boston Stadium",
      "city": "Boston",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "gillette"
    },
    {
      "id": 47,
      "stage": "group",
      "group": "L",
      "matchday": 2,
      "home": "PAN",
      "away": "CRO",
      "utcDateTime": "2026-06-23T23:00:00Z",
      "stadium": "BMO Field",
      "stadiumFifa": "Toronto Stadium",
      "city": "Toronto",
      "hostCountry": "ca",
      "timezone": "America/Toronto",
      "venueId": "bmo"
    },
    {
      "id": 48,
      "stage": "group",
      "group": "K",
      "matchday": 2,
      "home": "COL",
      "away": "COD",
      "utcDateTime": "2026-06-24T02:00:00Z",
      "stadium": "Estadio Akron",
      "stadiumFifa": "Estadio Guadalajara",
      "city": "Guadalajara",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "venueId": "akron"
    },
    {
      "id": 49,
      "stage": "group",
      "group": "B",
      "matchday": 3,
      "home": "SUI",
      "away": "CAN",
      "utcDateTime": "2026-06-24T19:00:00Z",
      "stadium": "BC Place",
      "stadiumFifa": "BC Place Vancouver",
      "city": "Vancouver",
      "hostCountry": "ca",
      "timezone": "America/Vancouver",
      "venueId": "bcplace"
    },
    {
      "id": 50,
      "stage": "group",
      "group": "B",
      "matchday": 3,
      "home": "BIH",
      "away": "QAT",
      "utcDateTime": "2026-06-24T19:00:00Z",
      "stadium": "Lumen Field",
      "stadiumFifa": "Seattle Stadium",
      "city": "Seattle",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "lumen"
    },
    {
      "id": 51,
      "stage": "group",
      "group": "C",
      "matchday": 3,
      "home": "SCO",
      "away": "BRA",
      "utcDateTime": "2026-06-24T22:00:00Z",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "city": "Miami",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "hardrock"
    },
    {
      "id": 52,
      "stage": "group",
      "group": "C",
      "matchday": 3,
      "home": "MAR",
      "away": "HTI",
      "utcDateTime": "2026-06-24T22:00:00Z",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "city": "Atlanta",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "mercedes"
    },
    {
      "id": 53,
      "stage": "group",
      "group": "A",
      "matchday": 3,
      "home": "CZE",
      "away": "MEX",
      "utcDateTime": "2026-06-25T01:00:00Z",
      "stadium": "Estadio Azteca",
      "stadiumFifa": "Estadio Ciudad de México",
      "city": "Mexico",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "venueId": "azteca"
    },
    {
      "id": 54,
      "stage": "group",
      "group": "A",
      "matchday": 3,
      "home": "RSA",
      "away": "KOR",
      "utcDateTime": "2026-06-25T01:00:00Z",
      "stadium": "Estadio BBVA",
      "stadiumFifa": "Estadio Monterrey",
      "city": "Monterrey",
      "hostCountry": "mx",
      "timezone": "America/Monterrey",
      "venueId": "bbva"
    },
    {
      "id": 55,
      "stage": "group",
      "group": "E",
      "matchday": 3,
      "home": "ECU",
      "away": "GER",
      "utcDateTime": "2026-06-25T20:00:00Z",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "city": "New York–NJ",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "metlife"
    },
    {
      "id": 56,
      "stage": "group",
      "group": "E",
      "matchday": 3,
      "home": "CUW",
      "away": "CIV",
      "utcDateTime": "2026-06-25T20:00:00Z",
      "stadium": "Lincoln Financial Field",
      "stadiumFifa": "Philadelphia Stadium",
      "city": "Philadelphie",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "lincoln"
    },
    {
      "id": 57,
      "stage": "group",
      "group": "F",
      "matchday": 3,
      "home": "TUN",
      "away": "NED",
      "utcDateTime": "2026-06-25T23:00:00Z",
      "stadium": "Arrowhead Stadium",
      "stadiumFifa": "Kansas City Stadium",
      "city": "Kansas City",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "arrowhead"
    },
    {
      "id": 58,
      "stage": "group",
      "group": "F",
      "matchday": 3,
      "home": "JPN",
      "away": "SWE",
      "utcDateTime": "2026-06-25T23:00:00Z",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "city": "Dallas",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "att"
    },
    {
      "id": 59,
      "stage": "group",
      "group": "D",
      "matchday": 3,
      "home": "TUR",
      "away": "USA",
      "utcDateTime": "2026-06-26T02:00:00Z",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "city": "Los Angeles",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "sofi"
    },
    {
      "id": 60,
      "stage": "group",
      "group": "D",
      "matchday": 3,
      "home": "PAR",
      "away": "AUS",
      "utcDateTime": "2026-06-26T02:00:00Z",
      "stadium": "Levi's Stadium",
      "stadiumFifa": "San Francisco Bay Area Stadium",
      "city": "San Francisco",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "levis"
    },
    {
      "id": 61,
      "stage": "group",
      "group": "I",
      "matchday": 3,
      "home": "NOR",
      "away": "FRA",
      "utcDateTime": "2026-06-26T19:00:00Z",
      "stadium": "Gillette Stadium",
      "stadiumFifa": "Boston Stadium",
      "city": "Boston",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "gillette"
    },
    {
      "id": 62,
      "stage": "group",
      "group": "I",
      "matchday": 3,
      "home": "SEN",
      "away": "IRQ",
      "utcDateTime": "2026-06-26T19:00:00Z",
      "stadium": "BMO Field",
      "stadiumFifa": "Toronto Stadium",
      "city": "Toronto",
      "hostCountry": "ca",
      "timezone": "America/Toronto",
      "venueId": "bmo"
    },
    {
      "id": 63,
      "stage": "group",
      "group": "H",
      "matchday": 3,
      "home": "URU",
      "away": "ESP",
      "utcDateTime": "2026-06-27T00:00:00Z",
      "stadium": "Estadio Akron",
      "stadiumFifa": "Estadio Guadalajara",
      "city": "Guadalajara",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "venueId": "akron"
    },
    {
      "id": 64,
      "stage": "group",
      "group": "H",
      "matchday": 3,
      "home": "CPV",
      "away": "KSA",
      "utcDateTime": "2026-06-27T00:00:00Z",
      "stadium": "NRG Stadium",
      "stadiumFifa": "Houston Stadium",
      "city": "Houston",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "nrg"
    },
    {
      "id": 65,
      "stage": "group",
      "group": "G",
      "matchday": 3,
      "home": "NZL",
      "away": "BEL",
      "utcDateTime": "2026-06-27T03:00:00Z",
      "stadium": "BC Place",
      "stadiumFifa": "BC Place Vancouver",
      "city": "Vancouver",
      "hostCountry": "ca",
      "timezone": "America/Vancouver",
      "venueId": "bcplace"
    },
    {
      "id": 66,
      "stage": "group",
      "group": "G",
      "matchday": 3,
      "home": "EGY",
      "away": "IRN",
      "utcDateTime": "2026-06-27T03:00:00Z",
      "stadium": "Lumen Field",
      "stadiumFifa": "Seattle Stadium",
      "city": "Seattle",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "lumen"
    },
    {
      "id": 67,
      "stage": "group",
      "group": "L",
      "matchday": 3,
      "home": "PAN",
      "away": "ENG",
      "utcDateTime": "2026-06-27T21:00:00Z",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "city": "New York–NJ",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "metlife"
    },
    {
      "id": 68,
      "stage": "group",
      "group": "L",
      "matchday": 3,
      "home": "CRO",
      "away": "GHA",
      "utcDateTime": "2026-06-27T21:00:00Z",
      "stadium": "Lincoln Financial Field",
      "stadiumFifa": "Philadelphia Stadium",
      "city": "Philadelphie",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "lincoln"
    },
    {
      "id": 69,
      "stage": "group",
      "group": "K",
      "matchday": 3,
      "home": "COL",
      "away": "POR",
      "utcDateTime": "2026-06-27T23:30:00Z",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "city": "Miami",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "hardrock"
    },
    {
      "id": 70,
      "stage": "group",
      "group": "K",
      "matchday": 3,
      "home": "COD",
      "away": "UZB",
      "utcDateTime": "2026-06-27T23:30:00Z",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "city": "Atlanta",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "mercedes"
    },
    {
      "id": 71,
      "stage": "group",
      "group": "J",
      "matchday": 3,
      "home": "JOR",
      "away": "ARG",
      "utcDateTime": "2026-06-28T02:00:00Z",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "city": "Dallas",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "att"
    },
    {
      "id": 72,
      "stage": "group",
      "group": "J",
      "matchday": 3,
      "home": "ALG",
      "away": "AUT",
      "utcDateTime": "2026-06-28T02:00:00Z",
      "stadium": "Arrowhead Stadium",
      "stadiumFifa": "Kansas City Stadium",
      "city": "Kansas City",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "arrowhead"
    },
    {
      "id": 73,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "2A",
      "away": "2B",
      "utcDateTime": "2026-06-28T19:00:00Z",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "city": "Los Angeles",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "sofi"
    },
    {
      "id": 74,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1E",
      "away": "3:ABCDF",
      "utcDateTime": "2026-06-29T20:30:00Z",
      "stadium": "Gillette Stadium",
      "stadiumFifa": "Boston Stadium",
      "city": "Boston",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "gillette"
    },
    {
      "id": 75,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1F",
      "away": "2C",
      "utcDateTime": "2026-06-30T01:00:00Z",
      "stadium": "Estadio BBVA",
      "stadiumFifa": "Estadio Monterrey",
      "city": "Monterrey",
      "hostCountry": "mx",
      "timezone": "America/Monterrey",
      "venueId": "bbva"
    },
    {
      "id": 76,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1C",
      "away": "2F",
      "utcDateTime": "2026-06-29T17:00:00Z",
      "stadium": "NRG Stadium",
      "stadiumFifa": "Houston Stadium",
      "city": "Houston",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "nrg"
    },
    {
      "id": 77,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1I",
      "away": "3:CDFGH",
      "utcDateTime": "2026-06-30T21:00:00Z",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "city": "New York–NJ",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "metlife"
    },
    {
      "id": 78,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "2E",
      "away": "2I",
      "utcDateTime": "2026-06-30T17:00:00Z",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "city": "Dallas",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "att"
    },
    {
      "id": 79,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1A",
      "away": "3:CEFHI",
      "utcDateTime": "2026-07-01T01:00:00Z",
      "stadium": "Estadio Azteca",
      "stadiumFifa": "Estadio Ciudad de México",
      "city": "Mexico",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "venueId": "azteca"
    },
    {
      "id": 80,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1L",
      "away": "3:EHIJK",
      "utcDateTime": "2026-07-01T16:00:00Z",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "city": "Atlanta",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "mercedes"
    },
    {
      "id": 81,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1D",
      "away": "3:BEFIJ",
      "utcDateTime": "2026-07-02T00:00:00Z",
      "stadium": "Levi's Stadium",
      "stadiumFifa": "San Francisco Bay Area Stadium",
      "city": "San Francisco",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "levis"
    },
    {
      "id": 82,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1G",
      "away": "3:AEHIJ",
      "utcDateTime": "2026-07-01T20:00:00Z",
      "stadium": "Lumen Field",
      "stadiumFifa": "Seattle Stadium",
      "city": "Seattle",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "lumen"
    },
    {
      "id": 83,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "2K",
      "away": "2L",
      "utcDateTime": "2026-07-02T23:00:00Z",
      "stadium": "BMO Field",
      "stadiumFifa": "Toronto Stadium",
      "city": "Toronto",
      "hostCountry": "ca",
      "timezone": "America/Toronto",
      "venueId": "bmo"
    },
    {
      "id": 84,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1H",
      "away": "2J",
      "utcDateTime": "2026-07-02T19:00:00Z",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "city": "Los Angeles",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "sofi"
    },
    {
      "id": 85,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1B",
      "away": "3:EFGIJ",
      "utcDateTime": "2026-07-03T03:00:00Z",
      "stadium": "BC Place",
      "stadiumFifa": "BC Place Vancouver",
      "city": "Vancouver",
      "hostCountry": "ca",
      "timezone": "America/Vancouver",
      "venueId": "bcplace"
    },
    {
      "id": 86,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1J",
      "away": "2H",
      "utcDateTime": "2026-07-03T22:00:00Z",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "city": "Miami",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "hardrock"
    },
    {
      "id": 87,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "1K",
      "away": "3:DEIJL",
      "utcDateTime": "2026-07-04T01:30:00Z",
      "stadium": "Arrowhead Stadium",
      "stadiumFifa": "Kansas City Stadium",
      "city": "Kansas City",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "arrowhead"
    },
    {
      "id": 88,
      "stage": "r32",
      "group": null,
      "matchday": null,
      "home": "2D",
      "away": "2G",
      "utcDateTime": "2026-07-03T18:00:00Z",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "city": "Dallas",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "att"
    },
    {
      "id": 89,
      "stage": "r16",
      "group": null,
      "matchday": null,
      "home": "W74",
      "away": "W77",
      "utcDateTime": "2026-07-04T21:00:00Z",
      "stadium": "Lincoln Financial Field",
      "stadiumFifa": "Philadelphia Stadium",
      "city": "Philadelphie",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "lincoln"
    },
    {
      "id": 90,
      "stage": "r16",
      "group": null,
      "matchday": null,
      "home": "W73",
      "away": "W75",
      "utcDateTime": "2026-07-04T17:00:00Z",
      "stadium": "NRG Stadium",
      "stadiumFifa": "Houston Stadium",
      "city": "Houston",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "nrg"
    },
    {
      "id": 91,
      "stage": "r16",
      "group": null,
      "matchday": null,
      "home": "W76",
      "away": "W78",
      "utcDateTime": "2026-07-05T20:00:00Z",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "city": "New York–NJ",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "metlife"
    },
    {
      "id": 92,
      "stage": "r16",
      "group": null,
      "matchday": null,
      "home": "W79",
      "away": "W80",
      "utcDateTime": "2026-07-06T00:00:00Z",
      "stadium": "Estadio Azteca",
      "stadiumFifa": "Estadio Ciudad de México",
      "city": "Mexico",
      "hostCountry": "mx",
      "timezone": "America/Mexico_City",
      "venueId": "azteca"
    },
    {
      "id": 93,
      "stage": "r16",
      "group": null,
      "matchday": null,
      "home": "W83",
      "away": "W84",
      "utcDateTime": "2026-07-06T19:00:00Z",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "city": "Dallas",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "att"
    },
    {
      "id": 94,
      "stage": "r16",
      "group": null,
      "matchday": null,
      "home": "W81",
      "away": "W82",
      "utcDateTime": "2026-07-07T00:00:00Z",
      "stadium": "Lumen Field",
      "stadiumFifa": "Seattle Stadium",
      "city": "Seattle",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "lumen"
    },
    {
      "id": 95,
      "stage": "r16",
      "group": null,
      "matchday": null,
      "home": "W86",
      "away": "W88",
      "utcDateTime": "2026-07-07T16:00:00Z",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "city": "Atlanta",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "mercedes"
    },
    {
      "id": 96,
      "stage": "r16",
      "group": null,
      "matchday": null,
      "home": "W85",
      "away": "W87",
      "utcDateTime": "2026-07-07T20:00:00Z",
      "stadium": "BC Place",
      "stadiumFifa": "BC Place Vancouver",
      "city": "Vancouver",
      "hostCountry": "ca",
      "timezone": "America/Vancouver",
      "venueId": "bcplace"
    },
    {
      "id": 97,
      "stage": "qf",
      "group": null,
      "matchday": null,
      "home": "W89",
      "away": "W90",
      "utcDateTime": "2026-07-09T20:00:00Z",
      "stadium": "Gillette Stadium",
      "stadiumFifa": "Boston Stadium",
      "city": "Boston",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "gillette"
    },
    {
      "id": 98,
      "stage": "qf",
      "group": null,
      "matchday": null,
      "home": "W93",
      "away": "W94",
      "utcDateTime": "2026-07-10T19:00:00Z",
      "stadium": "SoFi Stadium",
      "stadiumFifa": "Los Angeles Stadium",
      "city": "Los Angeles",
      "hostCountry": "us",
      "timezone": "America/Los_Angeles",
      "venueId": "sofi"
    },
    {
      "id": 99,
      "stage": "qf",
      "group": null,
      "matchday": null,
      "home": "W91",
      "away": "W92",
      "utcDateTime": "2026-07-11T21:00:00Z",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "city": "Miami",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "hardrock"
    },
    {
      "id": 100,
      "stage": "qf",
      "group": null,
      "matchday": null,
      "home": "W95",
      "away": "W96",
      "utcDateTime": "2026-07-12T01:00:00Z",
      "stadium": "Arrowhead Stadium",
      "stadiumFifa": "Kansas City Stadium",
      "city": "Kansas City",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "arrowhead"
    },
    {
      "id": 101,
      "stage": "sf",
      "group": null,
      "matchday": null,
      "home": "W97",
      "away": "W98",
      "utcDateTime": "2026-07-14T19:00:00Z",
      "stadium": "AT&T Stadium",
      "stadiumFifa": "Dallas Stadium",
      "city": "Dallas",
      "hostCountry": "us",
      "timezone": "America/Chicago",
      "venueId": "att"
    },
    {
      "id": 102,
      "stage": "sf",
      "group": null,
      "matchday": null,
      "home": "W99",
      "away": "W100",
      "utcDateTime": "2026-07-15T19:00:00Z",
      "stadium": "Mercedes-Benz Stadium",
      "stadiumFifa": "Atlanta Stadium",
      "city": "Atlanta",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "mercedes"
    },
    {
      "id": 103,
      "stage": "third",
      "group": null,
      "matchday": null,
      "home": "L101",
      "away": "L102",
      "utcDateTime": "2026-07-18T21:00:00Z",
      "stadium": "Hard Rock Stadium",
      "stadiumFifa": "Miami Stadium",
      "city": "Miami",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "hardrock"
    },
    {
      "id": 104,
      "stage": "final",
      "group": null,
      "matchday": null,
      "home": "W101",
      "away": "W102",
      "utcDateTime": "2026-07-19T19:00:00Z",
      "stadium": "MetLife Stadium",
      "stadiumFifa": "New York New Jersey Stadium",
      "city": "New York–NJ",
      "hostCountry": "us",
      "timezone": "America/New_York",
      "venueId": "metlife"
    }
  ]
}
